import React from 'react';
import { DataProviderInstance } from '../../../../../../api/DataProvider';
import PackagePurchaseFlow from '../../../../../../components/package-purchase/PackagePurchaseFlow';
import WalletPackages from './WalletPackages';
import WalletHistory from './WalletHistory';
import WalletEmptyState from './WalletEmptyState';
import WalletLoading from './WalletLoading';
import styles from './WalletSection.module.css';

/**
 * Bloco "Pacotes" do Financeiro: um cartão por pacote comprado e as
 * movimentações. Os números (sessões, vencimento, saldo) ficam no resumo do
 * topo da aba, por isso não se repetem aqui.
 *
 * Os dados vêm de `usePatientWallet` (quem orquestra a aba também usa o resumo)
 * e a venda (`PackagePurchaseFlow`) abre por `purchaseOpen` + `onPurchaseOpenChange`.
 */
const WalletSection = ({ wallet, packages, transactions, loading, onRefresh, purchaseOpen, onPurchaseOpenChange }) => {
  const { CompanyConfig } = DataProviderInstance();
  const hasPackages = packages.length > 0;
  const hasHistory = transactions.length > 0;

  return (
    <div className={styles.wallet}>
      <PackagePurchaseFlow
        companyConfig={CompanyConfig}
        walletId={wallet?.wallet_id}
        onPurchaseComplete={onRefresh}
        open={purchaseOpen}
        onClose={() => onPurchaseOpenChange(false)}
      />

      {loading ? (
        <WalletLoading />
      ) : (
        <>
          {hasPackages ? <WalletPackages packages={packages} /> : <WalletEmptyState onPurchase={() => onPurchaseOpenChange(true)} />}
          {(hasPackages || hasHistory) && <WalletHistory transactions={transactions} />}
        </>
      )}
    </div>
  );
};

export default WalletSection;
